import { FormHelperText, Input, InputLabel, Toolbar } from '@mui/material'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { updateUserid, updateUsername } from '../../../store/userSlice'
import styled from 'styled-components'
import TextBox from '../../Common/TextBox'
import { BlueButton } from '../../Layout/CommonStyle'
import { useEffect, useState } from 'react'
import { axiosPost } from '../../Common/Axios'
import toast from 'react-hot-toast'
import { ApiResult } from '../../../models/Enums'

// type Props = {
//   menuIndex: number
// }Main

function MainInfo() {
  const me = useAppSelector((state: RootState) => state.user.me)
  const dispatch = useAppDispatch()

  const [userid, setUserid] = useState<string>('')
  const [username, setUsername] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  useEffect(() => {
    setUserid(me.userid)
    setUsername(me.username)
    setEmail(me.email)
  }, [me])

  const handleSave = async () => {
    if (userid.trim().length === 0) {
      alert('아이디를 입력하세요')
      return
    }
    if (username.trim().length === 0) {
      alert('사용자 이름을 입력하세요')
      return
    }
    const payload = {
      userid,
      username,
      email,
    }

    const result = await axiosPost('/api/user/update_my_user_info', payload)
    if (result.apiResult != ApiResult.SUCCESS) {
      toast.error('저장에 실패했습니다.')
      return
    }

    dispatch(updateUsername(username))
    dispatch(updateUserid(userid))

    toast.success('저장했습니다.')
  }
  // const updateUserid = (newUserid: string) => {
  //   setUseri
  // }
  // const updateUsername = (newUsername: string) => {
  //   dispatch(updateUsername({ oldUsername: me.username, newUsername }))
  // }
  // const updateEmail = (newUsername: string) => {
  //   dispatch(updateUsername({ oldUsername: me.username, newUsername }))
  // }

  return (
    <Container>
      {/* <Header>{me.username}</Header> */}
      {!me.isUpdatePassword && (
        <Email>
          <div>처음 시작할 때 이름을 변경하세요.</div>
          <div>아이디는 처음에 한해서 1회 변경 가능합니다.</div>
          <div>
            E-mail을 등록하면 새로운 직업 정보를 메일로 받을 수 있습니다.
          </div>
        </Email>
      )}

      <Line>
        <InputLabel htmlFor="component-disabled">아이디</InputLabel>
        <input
          type="text"
          placeholder="아이디"
          value={userid}
          onChange={(e) => setUserid(e.target.value)}
        />
      </Line>

      <Line>
        <InputLabel htmlFor="component-disabled">사용자이름</InputLabel>
        <input
          type="text"
          placeholder="이름"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </Line>
      <Line>
        <InputLabel htmlFor="component-disabled">E-mail</InputLabel>
        <input
          type="text"
          placeholder="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Line>
      <ButtonBar>
        <BlueButton onClick={() => handleSave()}>저장</BlueButton>
      </ButtonBar>
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
`
const Header = styled.div`
  font-size: 2rem;
  font-weight: bold;
`
const Email = styled.div`
  font-size: 1rem;
  padding: 20px 0;
  color: #f38;
`

const Line = styled.div`
  padding: 10px 0;
  input {
    padding: 10px;
    font-size: 1rem;
    width: 80%;

    &::placeholder {
      color: #ccc;
    }
  }
`
const ButtonBar = styled.div`
  padding: 0px;
`
export default MainInfo
